"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var adminRoles = ['admin', 'owner'];
/**
 * Returns true if given role should be considered an 'admin'
 */
var isAdminRole = function (role) {
    return Boolean(role && adminRoles.includes(role));
};
exports.default = isAdminRole;
